import styled from "styled-components";
// 본문 폭 제한 컨테이너 (화면이 좁으면 100%)
export default styled.div`
  width: 100%;
  max-width: 65rem;
`;
